import * as d3 from 'd3'
import customFormatters from '@/filters/customFormatters'

export default {
  name: 'PieChart',
  mixins: [],
  components: {},
  props: {
    percentage: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      required: true
    },
    extra: {
      type: Number,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    colors: {
      type: Array,
      required: true
    },
    margin: {
      type: Object,
      default: () => ({ top: 16, right: 0, bottom: 6, left: 0 }),
      required: false
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  mounted () {
    this.draw()
  },
  methods: {
    draw () {
      const wrapper = this.$refs.wrapper.getBoundingClientRect()
      const width = wrapper.width - (this.margin.left + this.margin.right)
      const height = wrapper.height - (this.margin.top + this.margin.bottom)

      const colorScale = d3.scaleOrdinal().range(this.colors)

      const svg = d3.select(this.$refs.svg)
        .attr('width', `${wrapper.width}px`)
        .attr('height', `${wrapper.height}px`)

      const g = svg.append('g')
        .attr('transform', `translate(${width / 2}, ${(height / 2) + this.margin.top})`)

      const data = this.prepareData()
      const radius = Math.min(width, height) / 2
      const pie = d3.pie().padAngle(0).sort(null).value(d => d.value)
      const arc = d3.arc().innerRadius(radius * 0.6).outerRadius(radius - 1)

      g.selectAll('path')
        .data(pie(data))
        .join('path')
        .attr('fill', d => colorScale(d.data.key))
        .attr('d', arc)

      let total = 0
      if (this.label === 'CTR') {
        total = customFormatters.filters.formatNumber(this.extra)
      } else {
        total = customFormatters.filters.formatNumber(d3.sum(data, d => d.value))
      }

      const textG = g.append('g')
        .attr('class', 'center-text-group')

      textG.append('text')
        .attr('class', 'center-value')
        .attr('text-anchor', 'middle')
        .text(`${total} ${this.percentage ? '%' : ''}`)

      textG.append('text')
        .attr('class', 'center-label')
        .attr('text-anchor', 'middle')
        .attr('dy', '1.2em')
        .text(this.label)
    },
    prepareData () {
      const data = {}
      for (const group of this.data) {
        for (const value of group.values) {
          data[value.key] = data[value.key] || {
            key: value.key,
            value: 0
          }
          data[value.key].value += value.value
        }
      }
      return Object.values(data)
    }
  }
}
